import { render, staticRenderFns } from "./CPAdmin.vue?vue&type=template&id=6964f3c2&"
import script from "../scripts/CPAdmin.js?vue&type=script&lang=js&"
export * from "../scripts/CPAdmin.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports